import { render, staticRenderFns } from "./SeguimientoEstatus.vue?vue&type=template&id=5c2104d4"
import script from "./SeguimientoEstatus.vue?vue&type=script&lang=js"
export * from "./SeguimientoEstatus.vue?vue&type=script&lang=js"
import style0 from "./SeguimientoEstatus.vue?vue&type=style&index=0&id=5c2104d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports